"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OperatingSystems;
(function (OperatingSystems) {
    OperatingSystems["WinPhone"] = "Windows Phone";
    OperatingSystems["WinRT"] = "Windows RT";
    OperatingSystems["Win"] = "Windows";
    OperatingSystems["iOS"] = "iOS";
    OperatingSystems["MacOS"] = "Mac OS X";
    OperatingSystems["Android"] = "Android";
    OperatingSystems["ChromeOS"] = "ChromeOS";
    OperatingSystems["Linux"] = "Linux";
    OperatingSystems["Unknown"] = "Unknown";
})(OperatingSystems = exports.OperatingSystems || (exports.OperatingSystems = {}));
const osRegExps = {};
osRegExps[OperatingSystems.WinPhone] = /windows\sphone/i;
osRegExps[OperatingSystems.WinRT] = /arm;/i;
osRegExps[OperatingSystems.Win] = /(windows|win32)/i;
osRegExps[OperatingSystems.iOS] = /(iPad|iPhone|iPod)/i;
osRegExps[OperatingSystems.MacOS] = /(macintosh|mac os x)/i;
osRegExps[OperatingSystems.Android] = /android/i;
osRegExps[OperatingSystems.ChromeOS] = /CrOS/i;
osRegExps[OperatingSystems.Linux] = /(linux|x11)/i;
var Browsers;
(function (Browsers) {
    Browsers["Opera"] = "(OPR/|Opera)";
    Browsers["Edge"] = "Edge";
    Browsers["MSIE"] = "Trident";
    Browsers["Chrome"] = "Chrome";
    Browsers["Firefox"] = "Firefox";
    Browsers["Safari"] = "Safari";
    Browsers["Unknown"] = "Unknown";
})(Browsers = exports.Browsers || (exports.Browsers = {}));
var DeviceTypes;
(function (DeviceTypes) {
    DeviceTypes["Desktop"] = "desktop";
    DeviceTypes["Mobile"] = "mobile";
    DeviceTypes["Other"] = "other";
})(DeviceTypes = exports.DeviceTypes || (exports.DeviceTypes = {}));
class EnvironmentHelper {
    /**
     * Returns the iOS version
     * Based on detectDevice can returns iPhone/iPad or just version number
     *
     * @return {string}
     */
    static getIOSVersion(_userAgent = userAgent) {
        const iOSVersionMatches = userAgent.match(new RegExp('(iPhone OS|CPU OS)' + ' ([\\d_]+)'));
        if (iOSVersionMatches) {
            return iOSVersionMatches[2].replace(/_/g, '.');
        }
        return 'Unknown';
    }
}
/**
 * Returns the Operating System the code is executed in
 *
 * @return {string}
 */
EnvironmentHelper.getOS = (_userAgent = userAgent) => {
    if (_userAgent.match(osRegExps[OperatingSystems.WinPhone])) {
        return OperatingSystems.WinPhone;
    }
    if (_userAgent.match(osRegExps[OperatingSystems.WinRT])) {
        return OperatingSystems.WinRT;
    }
    if (_userAgent.match(osRegExps[OperatingSystems.Win])) {
        return OperatingSystems.Win;
    }
    if (_userAgent.match(osRegExps[OperatingSystems.iOS])) {
        return OperatingSystems.iOS;
    }
    if (_userAgent.match(osRegExps[OperatingSystems.MacOS])) {
        return OperatingSystems.MacOS;
    }
    if (_userAgent.match(osRegExps[OperatingSystems.Android])) {
        return OperatingSystems.Android;
    }
    if (_userAgent.match(osRegExps[OperatingSystems.ChromeOS])) {
        return OperatingSystems.ChromeOS;
    }
    if (_userAgent.match(osRegExps[OperatingSystems.Linux])) {
        return OperatingSystems.Linux;
    }
    return OperatingSystems.Unknown;
};
/**
 * Returns the browser name
 *
 * @return {string}
 */
EnvironmentHelper.getBrowserName = (_userAgent = userAgent) => {
    if (_userAgent.match(Browsers.Opera)) {
        return Browsers.Opera;
    }
    if (_userAgent.match(Browsers.Edge)) {
        return Browsers.Edge;
    }
    if (_userAgent.match(Browsers.MSIE)) {
        return Browsers.MSIE;
    }
    if (_userAgent.match(Browsers.Chrome)) {
        return Browsers.Chrome;
    }
    if (_userAgent.match(Browsers.Firefox)) {
        return Browsers.Firefox;
    }
    if (_userAgent.match(Browsers.Safari)) {
        return Browsers.Safari;
    }
    return Browsers.Unknown;
};
/**
 * Returns the device type
 *
 * @return {string}
 */
EnvironmentHelper.getDeviceType = (_os = exports.os) => {
    switch (_os) {
        case OperatingSystems.Win:
        case OperatingSystems.MacOS:
        case OperatingSystems.WinRT:
        case OperatingSystems.ChromeOS:
        case OperatingSystems.Linux:
            return DeviceTypes.Desktop;
        case OperatingSystems.WinPhone:
        case OperatingSystems.iOS:
        case OperatingSystems.Android:
            return DeviceTypes.Mobile;
        case OperatingSystems.Unknown:
        default:
            return DeviceTypes.Other;
    }
};
EnvironmentHelper.canJoinOnWeb = (_deviceType = exports.deviceType, _os = exports.os, _browser = exports.browser) => {
    if (_deviceType !== DeviceTypes.Desktop) {
        return false;
    }
    let supportedBrowser = [];
    switch (_os) {
        case OperatingSystems.MacOS:
            supportedBrowser = [Browsers.Chrome];
            break;
        case OperatingSystems.Win:
        case OperatingSystems.WinRT:
            supportedBrowser = [Browsers.Chrome, Browsers.Edge];
            break;
        case OperatingSystems.Linux:
        default:
            supportedBrowser = [Browsers.Chrome];
            break;
    }
    return supportedBrowser.indexOf(_browser) > -1;
};
/**
 * Returns current screen resolution
 *
 * @return {string}
 */
EnvironmentHelper.getScreenResolution = (_screen = window.screen) => {
    if (_screen.width == null || typeof _screen.width === 'undefined' ||
        _screen.height == null || typeof _screen.height === 'undefined') {
        return 'Unknown';
    }
    return _screen.width + 'x' + _screen.height;
};
/**
 * Returns language from the browser
 *
 * @return {string}
 */
EnvironmentHelper.getLanguage = (_navigator = window.navigator) => {
    const lang = _navigator.language || _navigator.userLanguage;
    if (lang !== undefined && lang.length > 2) {
        return lang.substr(0, 2);
    }
    return lang;
};
exports.EnvironmentHelper = EnvironmentHelper;
// PlatformVersion: Helpers.Environment.pureOSVersion,
//             Platform: Helpers.Environment.platform,
//             Language: Helpers.Environment.language,
//             ScreenResolution: Helpers.Environment.screenResolution
const userAgent = window.navigator.userAgent;
exports.os = EnvironmentHelper.getOS();
exports.browser = EnvironmentHelper.getBrowserName();
exports.deviceType = EnvironmentHelper.getDeviceType();
exports.canJoinOnWeb = EnvironmentHelper.canJoinOnWeb();
exports.screenResolution = EnvironmentHelper.getScreenResolution();
exports.deviceLanguage = EnvironmentHelper.getLanguage();
exports.platform = window.navigator.platform;
